import React, { useRef, useEffect } from "react";
import ReactDOM from 'react-dom';
import './Modal.css'; // Assuming you have some basic styles for the modal
import { ReactComponent as Close } from '../../svg/close.svg';
import { ReactComponent as Edit } from '../../svg/edit.svg';


function ModalPassifDescription({ isOpen, setModif, passive, setOpen }) {
  const valeur = ["Malus majeur", "Malus", "Neutre", "Bonus", "Bonus Majeur"]
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setModif(false)
          setOpen(false)
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, passive]);
  }
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  if (!isOpen) return null;


  const handleModif = () => {
    setModif(true)
    setOpen(false)
  };
  return (
    <div className="modal-overlay">
      <div className='modal_flex' ref={wrapperRef}>
        <div className="close" onClick={() => setOpen(false)}>
          <Close></Close>
        </div>
        <div className="edit" onClick={() => handleModif()}>
          <Edit></Edit>
        </div>
        <div className='modal_title '>{passive.nom}</div>
        <div className="modal_bloc "><strong>Effet : </strong>{passive.effet}</div>
        <hr className="modal_separator" />
        <div className="modal_bloc "><strong>Origine : </strong>{passive.origine}</div>
        <hr className="modal_separator" />
        <div className="modal_bloc margin_right_2em ">{valeur[passive.valeur + 2]}</div>
      </div>
    </div>
  );
}

export default ModalPassifDescription;
